
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EditParametreEntiteDialogComponent } from './edit-parametre-entite-dialog/edit-parametre-entite-dialog.component';
import { ParametreEntiteService } from 'src/services/parametre-entite.service';
import { OrganisationModel } from 'src/models/pilotage/organisationModel';

@Component({
    selector: 'app-parametre-entite',
    templateUrl: './parametre-entite.component.html',
    styleUrls: ['./parametre-entite.component.scss'],
    imports: [
    MatProgressSpinnerModule,
    TranslateModule,
    MatIconModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatOptionModule
]
})
export class ParametreEntiteComponent implements OnInit {

  isLoading = false;
    searchTerm = '';
    filtreType: string = '';
    pageIndex = 0;
    pageSize = 10;
    totalItems = 0;
    pageSizeOptions: number[] = [5, 10, 25, 100];

    displayedColumns: string[] = [
      'nom',
      'raisonSociale',
      'nomLegal',
      'estActif',
      'neq',
      'idUnique',
      'estRaisonSocialeAffiche',
      'actions'
    ];

    dataSource!: MatTableDataSource<any>;
    allItems: OrganisationModel[] = [];
    filteredItems: OrganisationModel[] = [];
    affiches: OrganisationModel[] = [];

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    constructor(
      private parametreEntiteService: ParametreEntiteService,
      private changeDetectorRef: ChangeDetectorRef,
      private router: Router,
      public translate: TranslateService,
      private dialog: MatDialog
    ) {
      translate.setDefaultLang('fr');
      this.dataSource = new MatTableDataSource<any>([]);
    }

    ngOnInit(): void {
      this.loadData();
    }

    loadData(): void {
      this.isLoading = true;
      this.parametreEntiteService.obtenirDonnesEntites().subscribe((resultat) => {
        this.dataSource.data = resultat;
        this.allItems = resultat;
        this.isLoading = false;
      });
    }

    filtre(): void {
      this.applyFilters();
    }

    applyFilters(): void {
      let filtered = [...this.allItems];
      if (this.searchTerm && this.searchTerm.length > 2) {
        const textRechercher = this.searchTerm.trim().toLowerCase();
        filtered = filtered.filter(item => {
          const checkValue = (value: any): boolean => {
            if (value && typeof value === 'object') {
              return Object.values(value).some(v => checkValue(v));
            }
            return value && String(value).toLowerCase().includes(textRechercher);
          };
          return Object.values(item).some(value => checkValue(value));
        });
      }
      this.filteredItems = filtered.sort((a, b) => {
        if (a.aUtilisateursFictifs === b.aUtilisateursFictifs) {
          return a.nom.localeCompare(b.nom, 'fr', { sensitivity: 'base' });
        }
        return b.aUtilisateursFictifs ? 1 : -1;
      });
      this.totalItems = this.filteredItems.length;
      this.pageIndex = 0;
      this.paginer();
    }

    paginer(event?: PageEvent) {
      if (event) {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
      }
      const startIndex = this.pageIndex * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      this.affiches = this.filteredItems.slice(startIndex, endIndex);
      this.dataSource.data = this.affiches;
      this.changeDetectorRef.detectChanges();
    }

    sortDataChange(sortState: Sort) {
      this.paginer();
    }

    reinitialiserFiltre(): void {
      this.searchTerm = '';
      this.filtre();
    }

    editOrganisation(entiteId: number) {
      const organisation = this.allItems.find(d => d.entiteId == entiteId);
      const dialogRef = this.dialog.open(EditParametreEntiteDialogComponent, {
        data: organisation,
        width: '500px',
      });
      dialogRef.afterClosed().subscribe(result => {
         this.loadData();
      });
    }

}
